export const normalizeOrganizationPayload = (payload, customFieldKeys = []) => {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  const normalized = { ...payload };
  delete normalized._id;

  for (const fieldKey of customFieldKeys) {
    if (!(fieldKey in normalized) || normalized[fieldKey] === undefined) {
      normalized[fieldKey] = '';
    }
  }

  return normalized;
};

export const normalizeOrganizationQueryName = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  return value;
};
